var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", { staticClass: "row" }, [
      _c(
        "div",
        { staticClass: "col-sm-12" },
        [
          _c("header-list", {
            attrs: {
              title: _vm.pageTitle,
              placeholderSearch: _vm.searchPlaceholder,
              routeAddName: `${_vm.moduleCode}.${_vm.pageID}.create`,
              routeAddParams: { type: "item" },
              canAdd: _vm.canAdd,
              addTitle: _vm.addItemTitle,
              icon: _vm.icon,
            },
            on: { search: _vm.onSearch },
            scopedSlots: _vm._u(
              [
                _vm.canAdd
                  ? {
                      key: "buttons-right",
                      fn: function () {
                        return [
                          _c("router-link", {
                            staticClass:
                              "btn btn-main btn-rounded btn-sm min-w-auto my-0 px-3 d-flex flex-row align-items-center justify-content-center flex-nowrap d-sm-inline",
                            attrs: {
                              to: {
                                name: `${_vm.moduleCode}.${_vm.pageID}.create`,
                                params: { type: "group" },
                              },
                            },
                            domProps: { innerHTML: _vm._s(_vm.addGroup) },
                          }),
                        ]
                      },
                      proxy: true,
                    }
                  : null,
              ],
              null,
              true
            ),
            model: {
              value: _vm.query,
              callback: function ($$v) {
                _vm.query = $$v
              },
              expression: "query",
            },
          }),
          _vm._v(" "),
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col" }, [
              _c(
                "div",
                { attrs: { id: "accordion" } },
                _vm._l(_vm.list, function (item, idx) {
                  return item[_vm.columnParentId] == null
                    ? _c(
                        "div",
                        { key: `card-${idx}`, staticClass: "card accordion" },
                        [
                          _c("div", { staticClass: "card-header" }, [
                            _c(
                              "div",
                              { staticClass: "row no-gutters" },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "col d-flex justify-content-between",
                                    class: {
                                      "tbl-column-disabled": !item.status,
                                    },
                                    attrs: {
                                      id: "heading" + item.id,
                                      "data-toggle": "collapse",
                                      "data-target": "#collapse" + item.id,
                                      "aria-expanded":
                                        idx == 0 && _vm.numGroups == 1,
                                      "aria-controls": "collapse" + item.id,
                                    },
                                  },
                                  [_c("span", [_vm._v(_vm._s(item.name))])]
                                ),
                                _vm._v(" "),
                                _vm.checkActions
                                  ? _c("column-actions", {
                                      staticClass:
                                        "col-auto d-flex justify-content-end",
                                      attrs: {
                                        tag: "div",
                                        listClass: "actions",
                                        routeEdit: `${_vm.moduleInternalCode}.${_vm.pageID}.show.${_vm.routeGroupKey}`,
                                        deleteMsgTemplate:
                                          "global.msg.confirm.delete-group",
                                        canDetail: _vm.canDetail,
                                        canEdit: _vm.canEdit,
                                        canDelete: _vm.canDelete,
                                        row: item,
                                        index: idx,
                                        callbackDelete: _vm.onRemove,
                                      },
                                      on: { delete: _vm.deleteItem },
                                    })
                                  : _vm._e(),
                              ],
                              1
                            ),
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "collapse",
                              class: { show: idx == 0 && _vm.numGroups == 1 },
                              attrs: {
                                id: "collapse" + item.id,
                                "aria-labelledby": "heading" + item.id,
                                "data-parent": "#accordion",
                              },
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "card-body" },
                                [
                                  _c("table-data", {
                                    attrs: {
                                      showTitleData: false,
                                      data: item[_vm.columnChildrens],
                                      tableWrapperClass: "table-responsive",
                                      settings: _vm.table.settings,
                                      columns: _vm.tableColumns,
                                      inlineFilters: _vm.table.filters,
                                      autoUpdateFilter:
                                        _vm.table.autoUpdateFilter,
                                      addParamsToUrl: _vm.table.addParamsToUrl,
                                      loadingMsg: _vm.table.loadingMsg,
                                      notFoundMsg: _vm.table.notFoundMsg,
                                      orderByTemplate:
                                        _vm.table.orderByTemplate,
                                      showPagination: _vm.table.showPagination,
                                      tableInline: _vm.table.tableInline,
                                    },
                                    on: { "error-load": _vm.showError },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "body",
                                          fn: function ({
                                            row,
                                            index,
                                            remove,
                                          }) {
                                            return [
                                              _c(
                                                "td",
                                                {
                                                  class: [
                                                    _vm.tableColumns[0].class,
                                                    {
                                                      "tbl-column-disabled":
                                                        !row.status,
                                                    },
                                                  ],
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                                                " +
                                                      _vm._s(
                                                        row[
                                                          _vm.tableColumns[0]
                                                            .field
                                                        ]
                                                      ) +
                                                      "\n                                            "
                                                  ),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _vm.checkActions
                                                ? _c("column-actions", {
                                                    attrs: {
                                                      routeEdit: `${_vm.moduleInternalCode}.${_vm.pageID}.show.${_vm.routeItemKey}`,
                                                      canDetail: _vm.canDetail,
                                                      canEdit: _vm.canEdit,
                                                      canDelete: _vm.canDelete,
                                                      row: row,
                                                      index: index,
                                                      callbackDelete: remove,
                                                    },
                                                    on: {
                                                      delete: _vm.deleteItem,
                                                    },
                                                  })
                                                : _vm._e(),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      true
                                    ),
                                  }),
                                ],
                                1
                              ),
                            ]
                          ),
                        ]
                      )
                    : _vm._e()
                }),
                0
              ),
            ]),
          ]),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }